import type { MutationHookOptions } from '@apollo/client'
import { GetBookingsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkUpdateSpaceControlBookingDocument,
  BulkUpdateSpaceControlBookingMutation,
  BulkUpdateSpaceControlBookingMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  BulkUpdateSpaceControlBookingMutation,
  BulkUpdateSpaceControlBookingMutationVariables
>

export const useBulkEditBooking = ({ options }: { options?: Options }) => {
  const [UpdateSpacecontrolBookingMutation, { loading }] = useMutation(
    BulkUpdateSpaceControlBookingDocument,
    {
      ...options,
      awaitRefetchQueries: true,
      extractorFn: (data: BulkUpdateSpaceControlBookingMutation) =>
        data.spaceControlMutations.bulkUpdateSpacecontrolBooking,
    }
  )

  return {
    loading,
    updateSpacecontrolBooking(variables: BulkUpdateSpaceControlBookingMutationVariables) {
      return UpdateSpacecontrolBookingMutation({
        variables,
        refetchQueries: [GetBookingsDataTableDocument],
      })
    },
  }
}
